import React from "react";
import {
  FlatButton,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from "material-ui";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import images from "../../config/images";
import SendEmailDialog from "../Seminars/SendEmailDialog";
import {
  checkJapanese,
  copyHostURL,
  copyWebinarPublisherUrl,
  copyWebinarURL,
  getToken,
  getURL,
} from "../../lib";
import NotificationSystem from "react-notification-system";
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';

class InvitationTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSendEmailDialog: false,
      selectedInvitation: null,
    };
  }

  getInvitedUserNames = (ids) => {
    const idArray = ids.split(",");
    let userNames = this.props.emailAddressBook
      .filter((addr) => idArray.includes(addr.id.toString()))
      .map((u) => u.name)
      .join(", ");
    return userNames;
  };

  getRoomURL = (invitationRoom) => {
    let room = this.props.rooms.find((r) => r.fvroom_name === invitationRoom.room_name);

    if (room) {
      let hostURL = room.is_webinar
        ? copyWebinarPublisherUrl(
            room,
            this.props.domainDetails.domainUrlName,
            this.props.domainDetails.fvDomainType,
            this.props.domainDetails.admin_guest_url
          )
        : copyHostURL(
            room,
            this.props.domainDetails.domainUrlName,
            this.props.domainDetails.fvDomainType,
            this.props.domainDetails.admin_guest_url
          );
      let guestURL = room.is_webinar
        ? copyWebinarURL(
            room.fvroom_name,
            this.props.domainDetails.domainUrlName,
            this.props.domainDetails.fvDomainType,
            this.props.domainDetails.admin_guest_url
          )
        : getURL(
            room.fvroom_name,
            this.props.domainDetails.domainUrlName,
            this.props.domainDetails.fvDomainType,
            this.props.domainDetails.admin_guest_url
          );
      let ids = invitationRoom.invited_users.split(',')
      let selectedAddresses = this.props.emailAddressBook.filter(addr => {
        if(ids.includes(addr.id.toString())) {
          return addr
        }
      })
      return { hostURL, guestURL, isValid: true, room, selectedAddresses };
    } else {
      alert(checkJapanese() ? "該当の部屋が見つかりません" : "Room does not exists");
      return { hostURL: "", guestURL: "", isValid: false, room: null, selectedAddresses: [] };
    }
  };

  handleReSend = (invitation) => {
    const { hostURL, guestURL, isValid, room, selectedAddresses } = this.getRoomURL(
      invitation
    );

    if (isValid) {
      invitation.hostURL = hostURL;
      invitation.guestURL = guestURL;
      invitation.selectedAddresses = selectedAddresses;
      invitation.room = room;
      this.setState({ selectedInvitation: invitation }, () => {
        this.setState({ openSendEmailDialog: true });
      });
    }
  };

  showSuccessNotification = (message, level) => {
    const notification = this.refs.notificationSystem;
    notification.addNotification({
      message,
      level,
      position: "tr",
      autoDismiss: 60,
    });
  };

  render() {
    const tdStyle = {
      padding: "0px",
      borderRight: "1px solid #b8b8b8",
      textAlign: "center",
      whiteSpace: "pre-wrap",
      overflow: "hidden",
      padding: "0 10px",
      color: "#6B7c93",
    };

    return (
      <div style={{ height: "72vh", overflowX: "hidden", overflowY: "auto" }}>
        <FlatButton
          onClick={() => this.props.history.goBack()}
          icon={<NavigationArrowBack color="#3659A0" style={{ marginLeft: 0 }} />}
          label={<FormattedMessage id="transcriptions.back" />}
          labelStyle={{
            color: '#3659A0',
          }}
          style={{
            marginBottom: '5px',
          }}
        />
        <div className="inivitation-notification">
          <NotificationSystem ref="notificationSystem" />
        </div>
        {this.state.openSendEmailDialog && (
          <SendEmailDialog
            open={this.state.openSendEmailDialog}
            handleClose={() => {
              this.setState({ openSendEmailDialog: false, selectedInvitation: null });
            }}
            onSend={(message, level) => {
              this.props.fetchInvitations(getToken(), this.state.selectedInvitation.is_webinar);
              this.showSuccessNotification(message, level);
              this.setState({ openSendEmailDialog: false, selectedInvitation: null });
            }}
            addressBook={this.props.emailAddressBook}
            groups={this.props.groups}
            resend={true}
            isWebinar={this.state.selectedInvitation.is_webinar}
            invitation={this.state.selectedInvitation}
            sendEmailTo={this.state.selectedInvitation.room}
            hostURL={this.state.selectedInvitation.hostURL}
            guestURL={this.state.selectedInvitation.guestURL}
            user={this.props.user}
            onAddEmailAddress={() => {
              this.props.fetchEmailAddressBook(getToken());
            }}
          />
        )}
        <div style={{ fontSize: "18px", margin: "10px 0", color: "#4c4c4c" }}>
          <FormattedMessage id="emailAddressBook.invitationHistory" />
        </div>
        {
          <Table
            selectable={false}
            selectedColor="black"
            bodyStyle={{
              display: "contents",
            }}
            style={{ border: "1px solid #b8b8b8", minWidth: "612px" }}
          >
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="roomList.roomName" />}
                </TableRowColumn>
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="invitations.date" />}
                </TableRowColumn>
                <TableRowColumn
                  colSpan={3}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="invitations.invitedUsers" />}
                </TableRowColumn>
                <TableRowColumn
                  colSpan={2}
                  style={{ ...tdStyle, color: "#fff" }}
                >
                  {<FormattedMessage id="emailAddressBook.role" />}
                </TableRowColumn>
                <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="invitations.resend" />}
                </TableRowColumn>
              </TableRow>

              {this.props.isFetchingList ||
                !this.props.hasFecthedEmailAddressBook ||
                !this.props.hasFetchedRooms ||
                (this.props.invitations.length === 0 && (
                  <TableRow
                    selected={false}
                    className="light-row"
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={10} style={tdStyle}>
                      {this.props.isFetchingList ||
                      !this.props.hasFecthedEmailAddressBook ||
                      !this.props.hasFetchedRooms
                        ? <FormattedMessage id="invitations.fetchingInvitations" />
                        : <FormattedMessage id="invitations.noInvitationFound" />}
                    </TableRowColumn>
                  </TableRow>
                ))}

              {!(
                this.props.isFetchingList ||
                !this.props.hasFecthedEmailAddressBook ||
                !this.props.hasFetchedRooms
              ) &&
                this.props.invitations.map((invitation, index) => {
                  return (
                    <TableRow
                      key={index}
                      selected={false}
                      className={index % 2 == 0 ? "dark-row" : "light-row"}
                      style={{
                        backgroundColor: "#f2f3f6",
                        borderBottom: "1px solid #b8b8b8",
                      }}
                    >
                      <TableRowColumn colSpan={2} style={tdStyle}>
                        {invitation.room_name}
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tdStyle}>
                        {moment
                          .unix(invitation.date)
                          .format("YYYY-MM-DD HH:mm:ss")}
                      </TableRowColumn>
                      <TableRowColumn colSpan={3} style={tdStyle}>
                        {this.getInvitedUserNames(invitation.invited_users)}
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tdStyle}>
                        {
                          <FormattedMessage
                            id={"emailAddressBook." + invitation.role}
                          />
                        }
                      </TableRowColumn>
                      <TableRowColumn style={tdStyle}>
                        <IconButton
                          onTouchTap={(e) => this.handleReSend(invitation)}
                          iconStyle={{ width: "28px" }}
                          touchRippleColor="green"
                        >
                          <img src={images.sendIcon} alt={"部屋に入る"} />
                        </IconButton>
                      </TableRowColumn>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        }
      </div>
    );
  }
}

export default InvitationTable;



// WEBPACK FOOTER //
// src/components/Invitations/InvitationTable.js